import { useState } from "react";
import Link from "next/link";
import { Container, Row, Col } from "react-bootstrap";
import styles from '@assets/css/home.module.css'
import Swiper from "react-id-swiper";
import {
  FaRegComments,
  FaCalendarAlt,
  FaStar,
  FaStarHalfAlt,
} from "react-icons/fa";
import { isMobile } from "react-device-detect";
import { handleClassNames } from 'lib/cssHelpers'
import { googleReviews } from "../../lib/reviews";
import ReadMoreReact from "read-more-react/dist/components/ReadMoreReact";
import Image from "next/image";
import LazyLoad from "react-lazyload";

const Google = () => {

  const handleClasses = (classValue) => {
    return handleClassNames(classValue, styles);
  }


  const [swiper, setSwiper] = useState(null);
  const contentStyle = { marginTop: "20px" };

  const params = {
    // loop: true,
    slidesPerView: 3,
    grabCursor: true,
    breakpoints: {
      1024: {
        slidesPerView: 3,
      },
      769: {
        slidesPerView: 2,
      },
      576: {
        slidesPerView: 1,
      },
      320: {
        slidesPerView: 1,
      },
    },
  };
  const data = [
    {
      name: " Kate Dooley,",
      star: "5",
      content:
        "We are glad to have partnered with Open Bonnet. The customers we get through them are knowledgeable and value the use of genuine spares and labor warranty. This way we maintain a high standard of service.",
      img: "photo",
    },
    {
      name: " Kate Dooley,",
      star: "4",
      content:
        "Excellent customer service provided from start to finish, very professional and friendly. Nothing was a problem. Will most definitely use their services again.",
      img: "photo",
    },
    {
      name: " Kate Dooley,",
      star: "5",
      content:
        "Excellent customer service provided from start to finish, very professional and friendly. Nothing was a problem. Will most definitely use their services again.",
      img: "photo",
    },
  ];
  return (

    <Col xs={12} style={{ marginTop: "0px" }} className="google-left">
      <Swiper {...params} getSwiper={setSwiper}>
        {googleReviews?.map((e, index) => (
          <LazyLoad key={index}>
            <div className={`d-flex justify-content-center align-items-center flex-column mt-5 ${handleClasses("google-head")}`}>
              <div className={handleClasses("google-card")}>
                <div className={handleClasses("google-container")}>
                  <div className="pl-3">
                    <div className={handleClasses("google-text")}>
                      <div className="display-text-group">
                        <span className={handleClasses("displayed-text")} >
                          <ReadMoreReact
                            text={e.content}
                            min={80}
                            readMoreText={
                              <a className="text-primary">Read More</a>
                            }
                          />
                          {/* I was skeptical at first but since they are partnered
                          with Amazon it gave me a bit of confidence to avail
                          services from Open Bonnet.
                          <span className={handleClasses("hide")}>
                            They will assist you with the process and are highly
                            attentive to your queries and concerns. They help
                            their customers understand the sequences and does
                            the job nicely with real-time support. Highly
                            recommended car service and most specially available
                            through Amazon.
                          </span>
                          <div className={handleClasses("read-more-button")}>
                            <a className="text-primary">Read More</a>
                          </div> */}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-start pl-3">
                    <div className={handleClasses("profile")}>
                      <div className={handleClasses("pro-image")}>
                        <img
                          src={"/assets/reviews/" + e.img}
                          alt="Google"
                          decoding="async"
                          data-nimg="fill"
                        />
                      </div>
                    </div>
                    <p className={`p-2 ${handleClasses("google-text pro-info")}`}>
                      {" "}
                      {e.name}, <br />
                      <span className={handleClasses("pro-info-span")}>
                        {e.car}, {e.location}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </LazyLoad >
        ))}
      </Swiper >
    </Col >
  );
};

export default Google;

// <div style={{marginBottom:'3%'}} id="review">
// <img src="/assets/images/google.png" style={{position:'absolute',left:0}}/>
// <Container fluid>
//     <Row className="justify-content-center" style={{marginBottom:'3%'}}>
//       <Col lg={6} md={8}>
//         <div className="text-center">
//           <div className="header-all">Customer Reviews</div>
//         </div>
//       </Col>
//     </Row>
//     <Row className="justify-content-center" style={{paddingLeft:'10px',paddingRight:'10px'}}>

//     </Row>
// </Container>

// </div>
// {data.map((e,index)=>(
//   <Col lg={3} md={3} sm={12} className="google-main">
//     <div className="google-card">
//       <div className="d-flex justify-content-start pl-2" style={{marginTop:'35px'}}>
//           <img src="/assets/images/start.webp" className="star p-1"/>
//           <img src="/assets/images/start.webp" className="star p-1"/>
//           <img src="/assets/images/start.webp" className="star p-1"/>
//           <img src="/assets/images/start.webp" className="star p-1"/>
//         </div>
//         <div md={12} style={ isMobile ? contentStyleOne : contentStyle} className="pl-2">
//           <p style={{fontSize:'14px',fontWeight:'400',color:'#000',marginRight:'20px',textAlign:'left'}}>{e.content}</p>
//         </div>
//         <div className="d-flex justify-content-start align-items-center pl-2" style={{marginTop:'20px',padding:'10px'}}>
//           <img src={`/assets/images/${e.img}.webp`} className="profile"/>
//           <span className="p-2" style={{fontSize:'14px',fontWeight:'700',color:'#000'}}>{e.name}</span>
//         </div>
//     </div>
//   </Col>
//  ))
//   }
